export const iconFontAwesomeFilmVideoYoutube = (
	<i className="fa-solid fa-youtube"></i>
);
